import { bus } from './bus';

const MAP = { 0: ' ', 1: 'x', 2: 'z', 3: 'Shift', 9: 'Enter' };
const held = {};
let raf = null;

function poll() {
  const pads = navigator.getGamepads ? [...navigator.getGamepads()].filter(Boolean) : [];
  const p = pads[0];
  if (p) {
    for (const b in MAP) {
      const down = !!p.buttons[b]?.pressed;
      if (held[b] !== down) { held[b] = down; bus.post({ type: 'vkey', key: MAP[b], down }); }
    }
    let ax = p.axes[0] || 0, ay = p.axes[1] || 0;
    if (p.buttons[14]?.pressed) ax = -1;
    if (p.buttons[15]?.pressed) ax = 1;
    if (p.buttons[12]?.pressed) ay = -1;
    if (p.buttons[13]?.pressed) ay = 1;
    ax = Math.abs(ax) > 0.15 ? ax : 0;
    ay = Math.abs(ay) > 0.15 ? ay : 0;
    const k = `${ax.toFixed(2)},${ay.toFixed(2)},${(p.axes[2] || 0).toFixed(2)},${(p.axes[3] || 0).toFixed(2)}`;
    if (held.axes !== k) { held.axes = k; bus.post({ type: 'vaxis', ax, ay, rx: p.axes[2] || 0, ry: p.axes[3] || 0 }); }
  }
  raf = pads.length ? requestAnimationFrame(poll) : null;
}

export function watchGamepads(onChange) {
  const update = () => {
    const pads = navigator.getGamepads ? [...navigator.getGamepads()].filter(Boolean) : [];
    onChange(pads.map((p) => p.id));
    if (pads.length && !raf) raf = requestAnimationFrame(poll);
  };
  window.addEventListener('gamepadconnected', update);
  window.addEventListener('gamepaddisconnected', update);
  update();
  return () => {
    window.removeEventListener('gamepadconnected', update);
    window.removeEventListener('gamepaddisconnected', update);
  };
}

export function padLabel(id = '') {
  if (/dualsense|054c|playstation|wireless controller/i.test(id)) return 'DualSense PS5';
  if (/xbox|045e|xinput/i.test(id)) return 'Xbox Wireless';
  if (/8bitdo|2dc8/i.test(id)) return '8BitDo';
  return id.split('(')[0].trim().slice(0, 28) || 'Gamepad';
}
